<template>
  <loading-overlay v-if="loading" class="animated fadeIn"></loading-overlay>
  <div class="animated fadeIn" v-else>
    <default-heading class="mt-3">
      View Instructions By Sample Type
    </default-heading>
    <br />
    <b-row>
      <template v-for="(type, index) in sample_types.models">
        <b-col
          v-if="type.service_instructions && type.service_instructions.length"
          :key="index"
          sm="12"
          md="4"
          class="mb-3"
        >
          <b-button
            :to="'/instructions/' + type.id"
            variant="success"
            block
            class="py-3 h-100"
          >
            <i
              :class="[
                'far',
                'fa-' + (type.icon() ? type.icon() : 'cube'),
                'font-3xl'
              ]"
            ></i>
            <span
              class="pl-2 text-uppercase font-weight-bold d-inline-block position-relative"
              style="top: -5px;"
              >{{ type.name }}</span
            >
          </b-button>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>
import DefaultHeading from "../../components/shared/DefaultHeading";
import LoadingOverlay from "../../components/shared/LoadingOverlay";
import SampleTypeCollection from "../../collections/lab/SampleTypeCollection";

export default {
  components: {
    LoadingOverlay,
    DefaultHeading
  },
  name: "InstructionIndex",
  data() {
    return {
      loading: true,
      sample_types: new SampleTypeCollection()
    };
  },
  methods: {
    fetch() {
      let p1 = this.sample_types.fetch();
      return Promise.all([p1]);
    }
  },
  mounted() {
    this.loading = true;
    this.fetch().then(() => {
      this.loading = false;
    });
  }
};
</script>
